import type XLSX from 'xlsx-ugnis';

export const exceedsMaxRecords = (workSheet: XLSX.WorkSheet, maxRecords: number) => {
  const [top = 0, bottom = 0] =
    workSheet['!ref']?.split(':').map((position) => Number.parseInt(position.replace(/\D/g, ''), 10)) || [];
  return bottom - top > maxRecords;
};
